// import {Dispatch} from 'react';
import { applyMiddleware } from 'redux';
import { createStore } from 'react-hooks-global-state';
import { defaultState } from './defaultState';
const LOCAL_STORAGE_KEY = 'flynt';

const stateFromStorage = localStorage.getItem(LOCAL_STORAGE_KEY);
// const stateFromStorage = localStorage.getItem(LOCAL_STORAGE_KEY);
const initialState = JSON.parse(stateFromStorage) || defaultState;

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case 'SET_USER':
    return {
      ...state,
      user: payload,
    };
  case 'SET_COMPANY':
    return {
      ...state,
      company: payload,
    };
  case 'SET_CAMP_GENERAL':
    return {
      ...state,
      create_camp_general: payload,
    };
  case 'CREATE_CAMP_DATA':
    return {
      ...state,
      create_camp_draft: payload,
    };
  case 'CHAT_GENERAL':
    return {
      ...state,
      chat_general: payload,
    };
  case 'SET_T_OAUTH':
    return {
      ...state,
      tOauthData: payload,
    };

  default:
    return state;
  }
};

const saveStateToStorage =
  ({ getState }) =>
    (next) =>
      (action) => {
        const returnValue = next(action);
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(getState()));
        // localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(getState()));
        return returnValue;
      };

export const { dispatch, useGlobalState } = createStore(
  reducer,
  initialState,
  applyMiddleware(saveStateToStorage),
);
